import React, {Component, Fragment} from 'react';
import {Line} from "rc-progress";
import {jsonResponseHandler} from "../../utils/FetchHelper";
import * as InitStatus from "../../constants/common/InitializationStatus";
import fetch from "fetch-retry";
import If from "../common/control/If";
import RetryView from "../statistics/common/RetryView";
import Loading from "../common/Loading";
import {addPrefix} from "../../utils/UriUtil";
import {getSearchEngineStrokeColorByService} from "../statistics/common/CommonHelper";

class DashboardInflow extends Component {

  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    this.processTimer = null;
  }

  // Default state
  getDefaultState() {
    return {
      initialized: InitStatus.INIT_READY,
      pv: 0, searchEngine: 0, sns: 0, etc: 0,
      isEmpty: false
    };
  }

  // Component mount후 API 호출
  componentDidMount() {
    this.getInflow();
  }

  // Unmount하기전 timer clear
  componentWillUnmount() {
    if (this.processTimer) {
      clearTimeout(this.processTimer);
    }
  }

  // 상세 유입정보 호출
  getInflow = () => {
    const {dispatch} = this.props;
    this.setState({initialized: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix("/manage/statistics/dashboard/inflow.json"), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 2,
        retryDelay: 300,
        retryOn: [500]
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {
          const percentage = this.getPercentage(res.data.result);

          // Loading이 완료된후 process 애니메이션을 노출하기위해 최소 시간값을 대기한다.
          clearTimeout(this.processTimer);
          this.setState({initialized: InitStatus.INIT_SUCCESS}, () => {
            this.processTimer = setTimeout(() => {
              this.setState({
                searchEngine: percentage.searchEngine,
                sns: percentage.sns,
                etc: percentage.etc,
                isEmpty: (percentage.searchEngine + percentage.sns + percentage.etc == 0)
              });
            }, 500)
          });
        })
        .catch(e => {
          console.error(e);
          this.setState({initialized: InitStatus.INIT_FAIL});
        })
    });
  };


  // 퍼센테이지 계산
  getPercentage(data) {
    const {pv, searchEngine, sns, etc} = data;

    if (pv == 0) return this.getDefaultState();

    return {
      searchEngine: Number(searchEngine / pv * 100).toFixed(1),
      sns: Number(sns / pv * 100).toFixed(1),
      etc: Number(etc / pv * 100).toFixed(1)
    };
  }


  // Root rendering
  render() {
    const {searchEngine, sns, etc, initialized, isEmpty} = this.state;
    const {isDoing, isFail} = InitStatus.init(initialized, null);
    const searchStrokeColor = getSearchEngineStrokeColorByService();

    return (
      <div className="box_blog_type1 box_log">
        <strong className="tit_box">유입 채널</strong>
        <If condition={isFail}><RetryView retryCallback={this.getInflow}/></If>
        <If condition={!isFail}>
          <If condition={isEmpty}><p className="txt_none">유입된 경로가 없습니다.</p></If>
          <If condition={!isEmpty}>
            <Fragment>
              <dl className="list_statistic">
                <dt>검색</dt>
                <dd>{searchEngine}%
                  <Line className="bar_data"
                        percent={searchEngine}
                        strokeColor={searchStrokeColor}
                        strokeWidth="1.3"
                        trailColor="#eeeeee"
                        strokeLinecap="round"
                  />
                </dd>
              </dl>
              <dl className="list_statistic">
                <dt>SNS</dt>
                <dd>{sns}%
                  <Line className="bar_data"
                        percent={sns}
                        strokeColor="#00C3A9"
                        strokeWidth="1.3"
                        trailColor="#eeeeee"
                        strokeLinecap="round"
                  />
                </dd>
              </dl>
              <dl className="list_statistic">
                <dt>기타</dt>
                <dd>{etc}%
                  <Line className="bar_data"
                        percent={etc}
                        strokeColor="#9BA5AF"
                        strokeWidth="1.3"
                        trailColor="#eeeeee"
                        strokeLinecap="round"
                  />
                </dd>
              </dl>
            </Fragment>
          </If>
          <If condition={isDoing}><Loading/></If>
        </If>
      </div>
    );
  }
}

export default DashboardInflow;
